module.exports = __webpack_public_path__ + "static/img/solutionBanner.ea6a0d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/solutionBanner.jpg
// module id = UKJ6
// module chunks = 15